/**
 * What to tell an admin when a role change is refused (PRD-1695). Each
 * organization has its own roles, so a role from elsewhere reads as not found
 * (404) when its permissions are edited, and as invalid (400) when it is
 * assigned to a user. No status means the request never got an answer.
 */
export function roleChangeError(status, detail, fallback) {
  if (status === 403) return "You don't have permission to make this change.";
  if (status === 404 && detail === 'Role not found') return "This role isn't in your organization. Refresh the page and try again.";
  if (status === 400 && detail === 'Invalid role') return "This role isn't in your organization. Refresh the page and choose another.";
  return (typeof detail === 'string' && detail) || fallback;
}
